export default __webpack_public_path__ + "static/media/3.f61ec056.png";